<script>

/**
 * Vue: Fragment (fragment)
 * -----------------------------------------------------------------------------
 * Used to conditionally render a wrapper. See https://github.com/vuejs/rfcs/discussions/448#discussioncomment-5510561.
 *
 */
export default {
  name: 'Fragment',

  render(h) {
    if (this.$slots && this.$slots.default) {
      return this.$slots.default?.()
    }

    return null
  },
}
</script>
